/**
 * Base URL for routes mounted outside /api/v1 (e.g. public contact API).
 * Strips a trailing /api/v1 from REACT_APP_API_URL. Uses the same hostname as the SPA
 * in local dev so requests hit http://127.0.0.1:8000 when the UI is on 127.0.0.1:3000.
 */
export function getPublicApiBaseUrl() {
  const env = process.env.REACT_APP_API_URL;
  if (env && typeof env === 'string') {
    const stripped = env.replace(/\/?api\/v1\/?$/i, '').replace(/\/$/, '');
    if (stripped) return stripped;
  }
  if (typeof window === 'undefined') {
    return 'http://localhost:8000';
  }
  const { hostname, protocol } = window.location;
  if (hostname.includes('archonpm.com')) {
    return 'https://api.archonpm.com';
  }
  if (hostname.includes('render.com')) {
    return 'https://axiom-m0hi.onrender.com';
  }
  return `${protocol}//${hostname}:8000`;
}

/**
 * Full URL or path for POST /contact/sales.
 * In local development, returns a same-origin path so Create React App's "proxy"
 * (package.json → http://localhost:8000) forwards to FastAPI without browser CORS.
 * This avoids failures when REACT_APP_API_URL points at production or the API runs only on localhost:8000.
 */
export function getContactSalesUrl() {
  if (typeof window === 'undefined') {
    return 'http://localhost:8000/contact/sales';
  }
  const isLocal =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1';
  if (isLocal && process.env.NODE_ENV === 'development') {
    return '/contact/sales';
  }
  return `${getPublicApiBaseUrl()}/contact/sales`;
}

/** POST /api/v1/public/demo-requests — landing demo queue (master DB + sales email). */
export function getPublicDemoRequestUrl() {
  if (typeof window === 'undefined') {
    return 'http://localhost:8000/api/v1/public/demo-requests';
  }
  const isLocal =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1';
  if (isLocal && process.env.NODE_ENV === 'development') {
    return '/api/v1/public/demo-requests';
  }
  return `${getPublicApiBaseUrl()}/api/v1/public/demo-requests`;
}
